import { forwardRef, ForwardedRef } from 'react'

import { useTheme } from 'styled-components'

import { Delete } from '@corabank/icons'

import { ButtonRemoveFileProps } from './interface'
import * as Styled from './styles'

const ButtonRemoveFile = forwardRef<HTMLButtonElement, ButtonRemoveFileProps>(
  (
    { removeFile, onRemoveFile }: ButtonRemoveFileProps,
    ref: ForwardedRef<HTMLButtonElement>
  ): JSX.Element => {
    const themeColors = useTheme()

    return (
      <Styled.RemoveButton
        data-testid="file-upload__remove-button"
        onClick={(event) => removeFile(event, onRemoveFile)}
        ref={ref}
      >
        <Styled.Tooltip description="Deletar arquivo">
          <Delete size="small" color={themeColors.colors.mainPrimary} />
        </Styled.Tooltip>
      </Styled.RemoveButton>
    )
  }
)

ButtonRemoveFile.displayName = 'ButtonRemoveFile'

export { ButtonRemoveFile }
